module.exports = __webpack_public_path__ + "img/member.8a45c744.webp";